import { TappProvider } from '@/components/ui/TappProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Outlet } from 'react-router-dom';
import './lib/utils/sentry';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

function Root() {
  return (
    <QueryClientProvider client={queryClient}>
      <TappProvider>
        <Outlet />
        <ReactQueryDevtools initialIsOpen={false} position={'bottom'} />
      </TappProvider>
    </QueryClientProvider>
  );
}

export default Root;
